import { motion } from "framer-motion";

const ray = (i) => ({
  initial: { pathLength: 0, opacity: 0 },
  animate: {
    pathLength: 1,
    opacity: 1,
    transition: { delay: 0.55 + i * 0.09, duration: 0.45, ease: "easeOut" },
  },
});

const RAYS = ["M32 1v6", "M21 4l3 5.5", "M43 4l-3 5.5", "M11 11l5 4", "M53 11l-5 4"];

export const SplashScreen = () => (
  <motion.div
    data-testid="splash-screen"
    className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0E0E10]"
    exit={{ opacity: 0, scale: 1.05 }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
  >
    <div className="hero-bloom absolute inset-0" />

    <motion.svg width="130" height="130" viewBox="0 0 64 64" fill="none">
      <defs>
        <linearGradient id="splash-gold" x1="0" y1="0" x2="64" y2="64">
          <stop offset="0%" stopColor="#E8DCC0" />
          <stop offset="55%" stopColor="#C9A24B" />
          <stop offset="100%" stopColor="#8A6D2F" />
        </linearGradient>
      </defs>
      <g stroke="url(#splash-gold)" strokeWidth="1.8" strokeLinecap="square" strokeLinejoin="miter">
        {RAYS.map((d, i) => (
          <motion.path key={d} d={d} {...ray(i)} />
        ))}
        <motion.path
          d="M20 24 L26 16 H38 L44 24 L32 50 Z"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        />
        <motion.path
          d="M20 24 H44 M26 16 L24 24 M38 16 L40 24 M32 16 V24 M24 24 L32 50 M40 24 L32 50 M32 24 V50"
          strokeWidth="0.9"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.7 }}
        />
      </g>
    </motion.svg>

    <span className="mt-8 block overflow-hidden">
      <motion.span
        className="font-logo block text-4xl font-medium uppercase tracking-[0.4em] text-white"
        initial={{ y: "115%" }}
        animate={{ y: 0 }}
        transition={{ delay: 0.7, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      >
        Sun<span className="gold-text">rays</span>
      </motion.span>
    </span>

    <motion.p
      className="eyebrow mt-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 1.2, duration: 0.8 }}
    >
      Certified Loose Diamonds · Dubai
    </motion.p>

    <div className="mt-10 h-px w-40 overflow-hidden bg-white/10">
      <motion.div
        className="h-full bg-gradient-to-r from-[#C9A24B] to-[#E8DCC0]"
        initial={{ x: "-100%" }}
        animate={{ x: "0%" }}
        transition={{ duration: 1.8, ease: "easeInOut" }}
      />
    </div>
  </motion.div>
);
